import { api } from "./api"

type VoteResponse = {
  votes_count: number
  voted: boolean
}

export const votes = {
  create: (sampleId: number) =>
    api.post<VoteResponse>(`/samples/${sampleId}/vote`),

  destroy: (sampleId: number) =>
    api.delete<VoteResponse>(`/samples/${sampleId}/vote`),

  toggle: (sampleId: number, currentlyVoted: boolean) =>
    currentlyVoted ? votes.destroy(sampleId) : votes.create(sampleId),
}
